import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function Oferta1la1Curriculum() {
  const curriculum = [{
    title: 'O conversație inițială prin care înțeleg unde te afli.',
    desc: 'Prima parte a ședinței este dialog. Îmi spui ce simți că te ține pe loc, ce ai încercat, ce vrei să schimbi. Te ascult fără să te judec.'
  }, {
    title: 'Identificarea credinței-cheie care te blochează.',
    desc: 'Prin întrebări precise și tehnica de "săpat", ajungem la credința de la rădăcină. Nu cea pe care o vezi, ci cea care lucrează în fundal.'
  }, {
    title: 'Lucrul cu starea theta și transformarea credinței.',
    desc: 'Te ghidez într-o stare profundă de relaxare și conectare. De acolo, credința veche este eliberată și înlocuită cu una care îți susține viața.'
  }, {
    title: 'Verificare și integrare.',
    desc: 'Confirmăm la nivel subconștient că schimbarea s-a instalat. Discutăm despre cum se va manifesta și ce pași poți face între ședințe.'
  }, {
    title: 'Tehnici și exerciții personalizate.',
    desc: 'Primești afirmații, meditații și exerciții ghidate, adaptate exact pe tema ta. Pentru a continua lucrul și între ședințe.'
  }, {
    title: 'Susținere între ședințe (la pachet).',
    desc: 'Pentru cei care aleg pachetul de 6 ședințe, primești și susținere energetică între întâlniri și acces direct la mine pentru întrebări scurte.'
  }];
  return <section className="py-20 lg:py-32 bg-brand-cream relative" data-id="element-1696">
      <div className="max-w-4xl mx-auto px-6" data-id="element-1697">
        <SectionHeading title="Cum decurge o ședință 1 la 1 de Theta Healing®" data-id="element-1698" />

        <div className="space-y-5 mb-16" data-id="element-1699">
          {curriculum.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.08
        }} className="flex gap-4 items-start bg-white p-6 md:p-7 rounded-2xl shadow-sm border border-brand-text/5 hover:shadow-warm transition-shadow" data-id="element-1700">
              <div className="flex-shrink-0 mt-1 w-10 h-10 rounded-full bg-brand-gold/10 flex items-center justify-center" data-id="element-1701">
                <CheckCircle2 className="w-6 h-6 text-brand-gold" data-id="element-1702" />
              </div>
              <div data-id="element-1703">
                <h3 className="font-bold text-lg text-brand-text mb-2" data-id="element-1704">
                  {item.title}
                </h3>
                <p className="text-brand-textSec leading-relaxed" data-id="element-1705">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-1706">
          <CTAButton data-id="element-1707" />
        </motion.div>
      </div>
    </section>;
}